import { z } from 'zod';

export const VehiclePropsSchema = z.object({
  external_id: z.string().optional(),
  name: z.string().min(1, 'Name is required'),
  type: z.string().min(1, 'Type is required'),
  status: z.string().min(1, 'Status is required'),
  vintage_year: z.number().int().optional(),
  target_size: z.number().positive().optional(),
});

export const FundraisingOpportunityPropsSchema = z.object({
  external_id: z.string().optional(),
  name: z.string().min(1, 'Name is required'),
  stage: z.string().min(1, 'Stage is required'),
  target_amount: z.number().positive().optional(),
  committed_amount: z.number().positive().optional(),
  expected_close_date: z.string().date().optional(),
  owner_user_id: z.string().uuid().optional(),
  source: z.string().optional(),
  source_detail: z.string().optional(),
});

export type VehicleProps = z.infer<typeof VehiclePropsSchema>;
export type FundraisingOpportunityProps = z.infer<typeof FundraisingOpportunityPropsSchema>;
